import React from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import EnterCode from '../components/EnterCode';
import axios from 'axios';
import { verifyPhoneUrl, sendSmsUrl } from '../constants';

const VerifyPhone = () => {
    const { state } = useLocation();
    const navigate = useNavigate();
    const params = useParams();

    const callback = code => {
        axios
        .post(verifyPhoneUrl, {'phone_number': state.phone, 'otp': code, 'signup': params.usage === 'su' ? 1 : 0})
        .then(res => {
            if (params.usage === 'su') { // verify phone for signup 
                navigate("/");
            }
            if (params.usage === 'rp') { // verify phone for reset password
                console.log(res.data);
                navigate('/reset-password/'+res.data.uid+'/'+res.data.token);
            }
        })
        .catch(err => {
            console.log(err);
        });
    }

    const resendCode = () => {
        axios.post(sendSmsUrl, {'phone_number': state.phone}) 
        .then(res => {
        })
        .catch(err => {
            console.log(err);            
        })
    }

  return (
    <div class="flex flex-col gap-2 mt-4 lg:mt-8 items-center justify-center">
        <div  class="flex w-[600px] flex-col gap-2 items-center">
                <h3 class="text-xl font-medium leading-6 text-gray-900">A verification code has been sent to {state.phone}</h3>
                <p class="default_text">Enter Code</p>   
                <EnterCode callback={callback}/>
                <button class="default_btn w-[300px] mt-2" onClick={()=>resendCode()}>Resend Code</button>
        </div>
    </div>
  )  
}

export default VerifyPhone